import { getRotatedDimensions } from '@common-util/texture-util';
import { ColorFillTextureLayer } from '@models/classes/materials/color-fill-texture-layer';
import { Token } from '@models/classes/token';
import { ITrackedClass } from '@models/interfaces/tracked-class';
import { TextureParameters } from '../texture-stack';
import { IDrawOperations, TextureLayerRenderer } from './texture';

export class ColorFillTextureLayerRenderer extends TextureLayerRenderer<ColorFillTextureLayer> {
    modelToken = Token.ColorFillTextureLayer;

    paintTexture(
        texture: ColorFillTextureLayer,
        context: CanvasRenderingContext2D,
        parameters: TextureParameters,
        operations: IDrawOperations
    ) {
        this.drawInBlendedContext(
            texture,
            context,
            parameters,
            innerContext => {
                innerContext.fillStyle = texture.color.cssString();
                innerContext.fillRect(0, 0, innerContext.canvas.width, innerContext.canvas.height);
            },
            operations
        );
    }

    textureHasContent() {
        return true;
    }

    getNativeSize(texture: ColorFillTextureLayer) {
        const width = texture.width,
            height = texture.height;

        if (texture.wAngle !== 0) {
            return getRotatedDimensions(width, height, texture.wAngle);
        } else {
            return { width, height };
        }
    }

    update3dInternal(node: ITrackedClass<ColorFillTextureLayer>) {
        super.update3dInternal(node);
    }
}
